import http from "../../services/http";

const searchCollaboratorsApi = async (search) => {
  return await http("get", `v1/usuario/pesquisar_colaboradores?pesquisa=${search}`);
};

export { searchCollaboratorsApi };
